import React from 'react';
import {
  Box,
  Paper,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  Grid,
} from '@mui/material';
import { Search } from '@mui/icons-material';

/**
 * Filter Bar Component - Dashboard style
 * Provides consistent search and filter UI for list pages
 * 
 * @param {string} searchValue - Current search value
 * @param {function} onSearchChange - Search change handler
 * @param {string} searchPlaceholder - Search placeholder text
 * @param {array} filters - Array of filter configurations
 * @param {React.ReactNode} additionalFilters - Additional filter components
 * @param {object} sx - Additional styles
 */
const FilterBar = ({
  searchValue = '',
  onSearchChange,
  searchPlaceholder = 'Search...',
  filters = [],
  additionalFilters,
  sx = {},
}) => {
  return (
    <Paper sx={{ p: 2, mb: 3, borderRadius: 3, ...sx }}>
      <Grid container spacing={2} alignItems="center">
        {/* Search Field */}
        <Grid item xs={12} md={filters.length > 0 ? 6 : 12}>
          <TextField
            fullWidth
            size="small"
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search sx={{ color: '#999' }} />
                </InputAdornment>
              ),
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': { borderColor: '#875A7B' },
                '&.Mui-focused fieldset': { borderColor: '#875A7B' },
              },
            }}
          />
        </Grid>

        {/* Dynamic Filters */}
        {filters.map((filter, index) => (
          <Grid item xs={12} md={3} key={filter.name || index}>
            <FormControl fullWidth size="small">
              <InputLabel>{filter.label}</InputLabel>
              <Select
                value={filter.value}
                label={filter.label}
                onChange={(e) => filter.onChange(e.target.value)}
                sx={{
                  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#875A7B' },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#875A7B' },
                }}
              >
                <MenuItem value="">{filter.allLabel || `All ${filter.label}`}</MenuItem>
                {filter.options.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        ))}

        {/* Additional Filters */}
        {additionalFilters && (
          <Grid item xs={12} md={3}>
            {additionalFilters}
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

export default FilterBar;
